import i18n from "../i18n";
import Entities from "../Entities";
import { EntityConfig } from "../hooks/useEntity";
import { Feature } from "../api/types";

export interface MercuryContextUpdate {
  parameterKey: string;
  operator: "set";
  value: string;
}

function routeSegments(route: string) {
  return route.split("/").filter(Boolean);
}

function describePage(pathname: string) {
  const segments = routeSegments(pathname.replace(/^\/app/, ""));
  const entity = (Object.values(Entities) as EntityConfig[])
    .map((config) => ({ config, base: routeSegments(config.baseRoute ?? "") }))
    .filter(({ base }) => base.length > 0 && base.every((segment, i) => segments[i] === segment))
    .sort((a, b) => b.base.length - a.base.length)[0];

  if (!entity) return { page: segments[0] ?? "", pageMode: "" };

  const rest = segments.slice(entity.base.length);
  let pageMode = "list";
  if (rest.at(-1) === "edit") pageMode = rest.at(-2) === "0" ? "create" : "edit";
  else if (rest[0] === "import") pageMode = "import";
  else if (rest.length > 0) pageMode = "detail";

  // English names, so the bot sees the same page names as the documentation regardless of UI language
  return { page: entity.config.name(i18n.getFixedT("en")), pageMode };
}

export function buildMercuryContext(pathname: string, roles: string[], features: Feature[]): Record<string, string> {
  // const { page, pageMode } = describePage(pathname);
  return {
    // "global.page": page,
    // "global.pageMode": pageMode,
    "global.roles": roles.join(","),
    "global.features": features
      .filter((feature) => feature.enabled)
      .map((feature) => feature.name)
      .join(","),
  };
}

export function toContextUpdates(context: Record<string, string>): MercuryContextUpdate[] {
  return Object.entries(context).map(([parameterKey, value]) => ({ parameterKey, operator: "set" as const, value }));
}

// Mercury mounts the widget of a channel into the element with this id
export function widgetElementId(key: string) {
  return `mercury-widget-${key}`;
}
